import { Head } from "@inertiajs/react"

import { CARD_SIZES, CARD_WIDTHS, buildImageUrl, buildSrcSet } from "../../utils/imageUrl"

/**
 * Preloads a collection page's first listing-card image so the LCP element is
 * discoverable by the preload scanner from the document head rather than after
 * the parser reaches the card markup deep in the body.
 *
 * The widths, sizes and quality are hard-wired to the card contract
 * (FirearmCard → SafeImage → Image: CARD_WIDTHS / CARD_SIZES / quality 70) —
 * the browser runs candidate selection twice, once for this link and once for
 * the <img>, and any difference makes it download two variants of the LCP
 * image instead of one. `href` is the card <img>'s exact fallback `src`
 * (width 1200 — Image's `fallbackWidth`) so browsers that ignore
 * `imagesrcset` dedupe onto the same URL too.
 */
export const CardPreload = ({ src }) => {
    if (!src) return null

    const href = buildImageUrl(src, { width: 1200, quality: 70 })

    // An unservable src builds to "" — a preload with href="" fetches the
    // document itself, so emit nothing (the card shows its placeholder).
    if (!href) return null

    const srcSet = buildSrcSet(src, CARD_WIDTHS, 70)

    return (
        <Head>
            <link
                rel="preload"
                as="image"
                href={href}
                imageSrcSet={srcSet}
                imageSizes={CARD_SIZES}
                fetchPriority="high"
            />
        </Head>
    )
}
